<template>
  <v-snackbar
    :model-value="true"
    location="bottom"
    color="success"
    timeout="-1"
    transition="slide-y-reverse-transition"
    data-locator="documents-numbering-snackbar"
    :style="{'margin': $vuetify.display.mobile ? '16px' : '40px'}"
  >
    <div class="d-flex align-center column-gap-4 text--small" data-locator="text-content">
      <app-icon-ds
        icon="hourglass-start"
        weight="far"
        color="white"
        size="xs"
      />
      {{ $t("project.documents.DocumentsNumberingSnackbar.numberingSnackbarText") }}
    </div>
    <template #actions="{ attrs }">
      <div class="d-flex column-gap-4">
        <SnackBarButton v-bind="attrs" data-locator="refresh-button" @click="onRefresh">
          {{ $t("project.documents.DocumentsNumberingSnackbar.numberingSnackbarRefresh") }}
        </SnackBarButton>
        <SnackBarButton v-bind="attrs" data-locator="close-button" @click="onClose">
          {{ $t("project.documents.DocumentsNumberingSnackbar.numberingSnackbarClose") }}
        </SnackBarButton>
      </div>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import SnackBarButton from '@/common/buttons/SnackBarButton.vue'
import { GET_PAGINATED_DOCUMENTS, LOAD_FOLDERS_TREE } from '@/store/modules/documents/action_types'
import { SET_DOCUMENTS_PAGINATION, SET_NUMBERING_SNACKBAR_IS_OPEN } from '@/store/modules/documents/mutation_types'

export default {
  name: 'DocumentsNumberingSnackbar',
  components: { SnackBarButton },
  computed: {
    ...mapState('documents', ['documentsPagination']),
  },
  methods: {
    ...mapActions('documents', [GET_PAGINATED_DOCUMENTS, LOAD_FOLDERS_TREE]),
    ...mapMutations('documents', [SET_NUMBERING_SNACKBAR_IS_OPEN, SET_DOCUMENTS_PAGINATION]),
    onRefresh () {
      this.SET_DOCUMENTS_PAGINATION({ ...this.documentsPagination })
      this.GET_PAGINATED_DOCUMENTS()
      this.LOAD_FOLDERS_TREE()
    },
    onClose () {
      this.SET_NUMBERING_SNACKBAR_IS_OPEN(false)
    },
  },
}
</script>
